import React from "react";
import { withRouter } from "react-router";
import {
  getShouldHideStaticPageMenuAndSearch,
  getStaticPageLayout
} from "../redux/modules/staticPageLayout/selector";
import getIsGenericStaticPageRoute from "../lib/getIsGenericStaticPageRoute";
import connect from "../i18n/connect";

export default function withStaticPageLayout(WrappedComponent) {
  const mapStateToProps = (state, ownProps) => {
    const isGenericStaticPageRoute = getIsGenericStaticPageRoute(
      ownProps.location?.pathname
    );

    return {
      staticPageLayout: getStaticPageLayout(state),
      isGenericStaticPageRoute,
      shouldHideStaticPageMenuAndSearch: getShouldHideStaticPageMenuAndSearch(
        state,
        isGenericStaticPageRoute
      )
    };
  };

  @withRouter
  @connect(mapStateToProps)
  class WithStaticPageLayout extends React.Component {
    render() {
      return <WrappedComponent {...this.props} />;
    }
  }

  return WithStaticPageLayout;
}
